import { render, staticRenderFns } from "./IconChecked.vue?vue&type=template&id=9d1f1c12&"
import script from "./IconChecked.vue?vue&type=script&lang=ts&"
export * from "./IconChecked.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports